import { LOGOUT, SET_USER_MOBILE_TOKEN, SET_USER_PARAMETERS } from "../action-types/authentication";

// *******************************
//  SET USER PARAMETERS
// *******************************

export const setUserParameters = (userId, formId, registrationRef, registrationApproved, registrationState, mbPending, mbwayPending, organicUnits, brainAnswerAccess, hasSignatureCredits, internal, externalRepresentation ) => {
    return  {
        type: SET_USER_PARAMETERS,
        userId: userId,
        formId: formId,
        organicUnits: organicUnits,
        registrationRef: registrationRef,
        registrationApproved: registrationApproved,
        registrationState: registrationState,
        mbPending: mbPending,
        mbwayPending: mbwayPending,
        brainAnswerAccess: brainAnswerAccess,
        hasSignatureCredits: hasSignatureCredits,
        internal: internal,
        externalRepresentation: externalRepresentation
    };
}

// *******************************
//  CLEAR USER PARAMETERS
// *******************************

export const clearUserParameters = () => {
    return  {
        type: SET_USER_PARAMETERS,
        userId: null,
        formId: null,
        organicUnits: [],
        registrationRef: null,
        registrationApproved: true,
        mbPending: false,
        mbwayPending: false,
        brainAnswerAccess: false,
        hasSignatureCredits: false,
        internal: false,
        externalRepresentation: false
    };
}

// *******************************
//  SET USER MOBILE TOKEN
// *******************************

export const setUserMobileAuthToken = (mobileAuthToken) => {
    return  {
        type: SET_USER_MOBILE_TOKEN,
        mobileAuthToken: mobileAuthToken
    };
}